import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

import { ClickableAnyRewardConfig } from 'components/rewards/ClickableAnyRewardConfig';
import { Variant } from 'components/rewards/RewardOverview/types';

import { So5LeaderboardWrapper } from '../So5LeaderboardWrapper';
import type { UpcomingLeaderboard_so5Leaderboard } from './__generated__/index.graphql';

const Rewards = styled(Horizontal)`
  flex-wrap: wrap;
  white-space: nowrap;
`;

type Props = {
  so5Leaderboard: UpcomingLeaderboard_so5Leaderboard;
  onClick: () => void;
};

export const UpcomingLeaderboard = ({ so5Leaderboard, onClick }: Props) => {
  return (
    <So5LeaderboardWrapper
      so5Leaderboard={so5Leaderboard}
      onClick={onClick}
      right={
        <Rewards>
          {so5Leaderboard.totalRewardConfigs.map(rewardConfig => (
            <ClickableAnyRewardConfig
              key={rewardConfig.id}
              anyRewardConfig={rewardConfig}
              variant={Variant.OVERVIEW_INLINE}
              rarity={so5Leaderboard.mainRarityType || undefined}
              so5League={so5Leaderboard.so5League}
            />
          ))}
        </Rewards>
      }
    />
  );
};

UpcomingLeaderboard.fragments = {
  so5Leaderboard: gql`
    fragment UpcomingLeaderboard_so5Leaderboard on So5Leaderboard {
      slug
      mainRarityType
      totalRewardConfigs(highestConfigByType: true) {
        id
        ...ClickableAnyRewardConfig_anyRewardConfigInterface
      }
      so5League {
        slug
        ...ClickableAnyRewardConfig_so5League
      }
      ...So5LeaderboardWrapper_so5Leaderboard
    }
    ${ClickableAnyRewardConfig.fragments.anyRewardConfigInterface}
    ${ClickableAnyRewardConfig.fragments.so5League}
    ${So5LeaderboardWrapper.fragments.so5Leaderboard}
  ` as TypedDocumentNode<UpcomingLeaderboard_so5Leaderboard>,
};
